import React, { memo } from 'react';
import styled from 'styled-components';

const colors = {
  bg: {
    panel: '#FFFFFF',
    content: 'rgba(0,0,0,0.05)',
  },
  fg: {
    panel: 'rgba(0,0,0,0.8)',
    content: 'rgba(0,0,0,0.8)',
  },
};

const shadows = {
  left: '0 1px 1px 0 rgba(0,0,0,0.12)',
  bottom: '-1px 0 4px 0 rgba(0,0,0,0.15)',
};

const borders = ['1px solid #D9D9DE'];

const include = (styleName, property) => (props) => {
  // eslint-disable-next-line no-prototype-builtins
  if (props.hasOwnProperty(property)) {
    return `${styleName}: ${props[property]};`;
  }
  return `${styleName}: ${props[property]};`;
};

const Box = styled.div`
  display: flex;
  overflow: hidden;
  ${include('flex', 'flex')} ${include('flex-direction', 'flexDirection')} ${include(
  'justify-content',
  'justifyContent',
)} ${include('align-items', 'alignItems')} ${include('min-height', 'minHeight')} ${include(
  'width',
  'width',
)} ${include('max-width', 'maxWidth')} ${include('padding', 'padding')} ${include(
  'background-color',
  'bg',
)} ${include('color', 'fg')} ${include('border', 'border')} ${include('box-shadow', 'boxShadow')};
`;

/* layout exports */
const FullScreen = memo((props) => <Box flexDirection="column" minHeight="100vh" {...props} />);

const Body = memo((props) => <Box flexDirection="row" flex="1" maxWidth="100%" {...props} />);

const NavBar = memo((props) => (
  <Box
    flexDirection="row"
    width="100%"
    overflow="hidden"
    padding="0.83em 0"
    alignItems="center"
    bg={colors.bg.panel}
    border={borders[0]}
    boxShadow={shadows.bottom}
    justifyContent="space-between"
    {...props}
  />
));

const Content = memo((props) => (
  <Box
    flexDirection="column"
    justifyContent="center"
    flex="1"
    maxWidth="calc(100% - 344px)"
    fg={colors.fg.content}
    bg={colors.bg.content}
    {...props}
  />
));

const Sidebar = memo((props) => (
  <Box
    flexDirection="column"
    overflow="hidden"
    bg={colors.bg.panel}
    width="344px"
    border={borders[0]}
    boxShadow={shadows.left}
    padding="20px"
    {...props}
  />
));

export const NotYetAttemptedWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  h2 {
    text-align: center;
    border: dashed rgba(0, 0, 0, 0.3) 2px;
    border-radius: 3px;
    color: rgba(0, 0, 0, 0.3);
    padding: 20px;
  }
`;

export default memo(Box);

export { FullScreen, NavBar, Body, Content, Sidebar };
